<template>
  <div class="animated fadeIn">
    <div>
      <component-header
        title="Customer Detail View"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="true"
        @back-press="$router.push('/manage_own_customer')"
      />
    </div>
    <b-row>
      <b-col md="6">
        <div class="mx-2 p-4">
          <h3 class="h3-text">
            Customer Number :&nbsp;<span class="span-text">
              {{ currentUser.customerNo }}
            </span>
          </h3>
          <h3 class="h5-text">
            Mobile Number :&nbsp;<span class="span-text">
              {{ currentUser.phone }}
            </span>
          </h3>
          <h3 class="h5-text">
            Service ID :&nbsp;<span class="span-text">
              {{ currentUser.serviceId }}
            </span>
          </h3>
          <h3 class="h5-text">
            Country :&nbsp;<span class="span-text">
              {{ currentUser.address.country }}
            </span>
          </h3>
          <h3 class="h5-text">
            Street 1 :&nbsp;<span class="span-text">
              {{ currentUser.address.address1 }}
            </span>
          </h3>
          <h3 class="h5-text">
            State :&nbsp;<span class="span-text">
              {{ currentUser.address.state }}
            </span>
          </h3>
          <h3 class="h5-text">
            MSO :&nbsp;<span class="span-text"> {{ currentUser.MSO }} </span>
          </h3>
        </div>
      </b-col>
      <b-col md="6">
        <div class="mx-2 p-4">
          <h3 class="h5-text">
            Customer Name :&nbsp;<span class="span-text">
              {{ currentUser.customerName }}
            </span>
          </h3>
          <h3 class="h5-text">
            Email ID :&nbsp;<span class="span-text">
              {{ currentUser.email }}
            </span>
          </h3>
          <h3 class="h5-text">
            Service Type :&nbsp;<span class="span-text">
              {{ currentUser.serviceType }}
            </span>
          </h3>
          <h3 class="h5-text">
            City :&nbsp;<span class="span-text">
              {{ currentUser.address.city }}
            </span>
          </h3>
          <h3 class="h5-text">
            Street 2 :&nbsp;<span class="span-text">
              {{ currentUser.address.address2 }}
            </span>
          </h3>
          <h3 class="h5-text">
            Zipcode :&nbsp;<span class="span-text">
              {{ currentUser.address.pinCode }}
            </span>
          </h3>
        </div>
      </b-col>
    </b-row>
    <div style="margin-left: 28%" class="mb-5 mt-5">
      <button
        type="button"
        class="btn btn-lg btn-outline-success ml-1 w-25"
        @click="editCustomer()"
      >
        EDIT
      </button>
    </div>
  </div>
</template>
<script>
import editCustomer from "@/views/manageOwnCustomer/editCustomer";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "CustomerDetail",
  components: {
    editCustomer,
    ComponentHeader,
  },
  data() {
    return {
      isOpenModal: false,
      currentUser: {
        customerNo: "",
        customerName: "",
        createdDate: "",
        service: "",
        customerPhone: "",
        email: "",
        address: {
          address1: "",
          address2: "",
          state: "",
          city: "",
          pinCode: "",
          country: "",
        },
        _id: "",
        phone: "",
        serviceId: "",
        MSO: "",
        serviceType: "",
      },
      loading: false,
      partnerCustomers: {},
    };
  },
  methods: {
    viewCustomer(data) {
      this.isOpenModal = true;
    },
    editCustomer() {
      this.$router.push({
        name: "editCustomer",
        params: { userData: this.currentUser },
      });
    },
  },
  mounted: async function () {
    this.loading = true;
    this.currentUser = this.$route.params.userData;
    this.loading = false;
  },
};
</script>
